export default "__VITE_ASSET__Df82V5uS__"